import classNames from "classnames";
import useLabels from "hooks/useLabels";
import { useRef, useState } from "react";

type DiscountMessageProps = {
  onClickVerifyAccount: () => void;
  onClickShowInstructionToMergeAccount: () => void;
  onClickShowExistingEmailInstruction: () => void;
};

function DiscountMessage({
  onClickVerifyAccount,
  onClickShowInstructionToMergeAccount,
  onClickShowExistingEmailInstruction,
}: DiscountMessageProps) {
  const [expand, setExpand] = useState(false);
  const [pageLabels] = useLabels("screens.pricing");
  const ref = useRef<HTMLDivElement>(null);

  const handleClickVerifyAccount = (e: any) => {
    e.preventDefault();
    e.stopPropagation();
    onClickVerifyAccount();
  };

  const handleClickMergeAccount = (e: any) => {
    e.preventDefault();
    e.stopPropagation();
    onClickShowInstructionToMergeAccount();
  };

  const handleClickExistingEmail = (e: any) => {
    e.preventDefault();
    e.stopPropagation();
    onClickShowExistingEmailInstruction();
  };

  return (
    <div
      onClick={() => setExpand(!expand)}
      data-testid="discount-message"
      className="w-full py-4 bg-bg-base border cursor-pointer rounded-xl max-w-page"
    >
      <div className="flex items-center justify-between gap-4 px-4">
        <div className="flex-1">
          <h4 className="text-fg-base base-bold">
            {pageLabels["discount-title"]}
          </h4>
          <span className="mt-2 sm-normal text-fg-muted">
            {pageLabels["discount-message"]}
          </span>
        </div>
        <i
          className={classNames(
            "flex items-center justify-center text-xl w-5 h-5 p-5",
            expand ? "icon-chevron-up" : "icon-chevron-down"
          )}
        />
      </div>
      <div
        style={{
          height: expand
            ? ref.current?.clientHeight
              ? ref.current?.clientHeight + 13
              : "auto"
            : 0,
          transition: ".2s",
          overflow: "hidden",
        }}
      >
        <div className="px-4 mt-3 text-sm border-t" ref={ref}>
          <div
            className="flex items-center gap-3 p-3 mt-4 border rounded-xl"
            onClick={handleClickVerifyAccount}
          >
            <i className="text-xl leading-none text-fg-muted icon-check" />
            <div className="flex-1">
              <div className="sm-md text-fg-base">
                {pageLabels["discount-option1-title"]}
              </div>
              <div className="mt-1 text-fg-muted tiny-normal">
                {pageLabels["discount-option1-message"]}
              </div>
            </div>
          </div>

          <div
            className="flex items-center gap-3 p-3 mt-4 border rounded-xl"
            onClick={handleClickMergeAccount}
          >
            <i className="text-xl leading-none text-fg-muted icon-plus" />
            <div className="flex-1">
              <div className="sm-md text-fg-base">
                {pageLabels["discount-option2-title"]}
              </div>
              <div className="mt-1 text-fg-muted tiny-normal">
                {pageLabels["discount-option2-message"]}
              </div>
            </div>
          </div>

          <div
            className="flex items-center gap-3 p-3 mt-4 border rounded-xl"
            onClick={handleClickExistingEmail}
          >
            <i className="text-xl leading-none text-fg-muted icon-mail" />
            <div className="flex-1">
              <div className="sm-md text-fg-base">
                {pageLabels["discount-option3-title"]}
              </div>
              <div className="mt-1 text-fg-muted tiny-normal">
                {pageLabels["discount-option3-message"]}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default DiscountMessage;
